import React, { useState, useEffect, Fragment } from 'react';
import { buildDate } from '../../../../utils/buildInfo';
import moment from 'moment';

const buildDateGreaterThan = (latestDate: number, currentDate: number) => {
  const momLatestDateTime = moment(latestDate);
  const momCurrentDateTime = moment(currentDate);

  return momLatestDateTime.isAfter(momCurrentDateTime);
};

function withClearCache<T>(Component: React.ComponentType<T>) {
  return (props: T) => {
    const [isLatestBuildDate, setIsLatestBuildDate] = useState(false);

    useEffect(() => {
      fetch('/opweb-meta.json')
        .then((response) => response.json())
        .then((meta) => {
          const latestVersionDate = meta.buildDate;
          const currentVersionDate = buildDate;
          // No build date in index.html (meta tag missing): don't risk a reload loop.
          if (!meta.buildDate || !currentVersionDate) {
            console.log('Could not fetch latest version information');
            setIsLatestBuildDate(true);
          } else {
            console.log('Latest Build code: ' + meta.buildDate);

            const shouldForceRefresh = buildDateGreaterThan(latestVersionDate, currentVersionDate);
            if (shouldForceRefresh) {
              setIsLatestBuildDate(false);
              refreshCacheAndReload();
            } else {
              setIsLatestBuildDate(true);
            }
          }
        })
        .catch((error) => {
          console.log('Could not fetch latest version information. Error caught:');
          console.log(error);
          setIsLatestBuildDate(true);
        });
    }, []);

    const refreshCacheAndReload = async () => {
      // Service worker cache should be cleared with caches.delete()
      if (caches) {
        const names = await caches.keys();
        console.log(names);
        await Promise.all(names.map((name) => caches.delete(name)));
      }
      console.log('Loading latest version');
      window.location.reload();
    };

    return <Fragment>{isLatestBuildDate && <Component {...props} />}</Fragment>;
  };
}

export default withClearCache;
